import React, { FC } from "react";
import { RouterParamType } from "@/model/navModel";
import { BaseFormBox } from "./BaseFormBox";
import { Form } from "@/components/YhFormBox";
import { IForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { TransportFormBox } from "./TransportFormBox";
import { useShipmentDetailModel } from "../shipmentDetailModel";
import { TableBoxAdded } from "./TableBoxAdded";
import { SettleDrawer } from "./SettleDrawer";
import { FormBoxItem } from "../box/FormBoxItem";
import { IShipmentTabEnum } from "@/views/shipment/shimentTypes";
import { ReceiptSettleDrawer } from "./receiptSettleDrawer";

export const BaseDetail: FC<RouterParamType> = ({ formRef, ...detailsInfo }) => {

    const { editFormVal, tabActive, updateFormVal } = useShipmentDetailModel();
    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        updateFormVal(changedValues);
    }
    const fromConfig: IForm = {
        formRef: formRef as React.MutableRefObject<IYhFormRef<any>>,
        labelCol: { span: 8 },
        labelAlign: "right",
        onChange,
        formValues: editFormVal,
    }

    return (
        <>
            <Form {...fromConfig}>
                <div style={{ width: "100%" }} hidden={tabActive !== IShipmentTabEnum.BASE_DETAIL}>
                    <BaseFormBox {...detailsInfo} />
                    <TransportFormBox {...detailsInfo} />
                    <TableBoxAdded {...detailsInfo} />
                </div>
                <div style={{ width: "100%" }} hidden={tabActive !== IShipmentTabEnum.BOX_INFO}>
                    <FormBoxItem {...detailsInfo} />
                </div>
            </Form>
            {/* <SettleDrawer /> */}
            <ReceiptSettleDrawer />
        </>
    )
}